import React from 'react';
import Pagination from 'react-paginating';

import { rootConfig } from '../../../config/config';
import {
  AuthorAndTime,
  Title,
  ListElement,
  ListPageItem,
  PageItem,
  Card,
  CardData,
  CardHolder
} from '../StyledComponents/index';
import { StyledLine, StyledLineInside } from '../StyledComponents/StyledLine';
import MainListLoader from '../Loaders/MainListLoader';

const articleList = props => {
  // console.log('props: ', props);
  const { data, contentData, clicked, title } = props;
  const { total, pageCount, currentPage, limit } = data;

  let cards = null;
  if (contentData) {
    cards = contentData.map((res, index) => {
      // console.log('res: ', res);
      return (
        <Card onClick={() => clicked(res.slug)} key={index}>
          <div className="ImageDiv flex justify-center items-center">
            <div
              style={{
                width: '225px',
                height: '112.5px',
                // background: `url(${rootConfig.imagesRoot}/${
                //   res.featuredImage.file
                // })`,
                background: `${
                  res.featuredImage
                    ? `url(${rootConfig.imagesRoot}/${res.image})`
                    : 'black'
                }`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center'
              }}
            />
            {/* <img
              src={
                res.featuredImage
                  ? `${rootConfig.imagesRoot}/${res.featuredImage.file}`
                  : null
              }
              alt={res.postSlug}
              className="w-100 mw7 w5-ns"
            /> */}
          </div>
          <CardData>
            <Title
              fontFamily="Nunito"
              fontSize="1.3rem"
              fontWeight="bold"
              lineHeight="1.25"
            >
              {res.title}
            </Title>
            <AuthorAndTime
              color="#8e8e8e"
              fontSize="0.75rem"
              fontWeight="normal"
            >
              <div>{res.postAuthor}</div>
              <div>{res.postDate}</div>
            </AuthorAndTime>
          </CardData>
        </Card>
      );
    });
  }

  return (
    <ListElement className="left-container" padding="2.25rem 1.2rem">
      <Title fontFamily="Montserrat" fontSize="2.25rem" fontWeight="bold">
        {title}
      </Title>
      <StyledLine>
        <StyledLineInside />
      </StyledLine>

      {/* Load Recent News Medium Like spinner instead of null in below line */}
      {cards !== null ? <CardHolder>{cards}</CardHolder> : <MainListLoader />}

      <Pagination
        total={total}
        limit={limit}
        pageCount={pageCount}
        currentPage={currentPage}
      >
        {({
          pages,
          currentPage,
          hasNextPage,
          hasPreviousPage,
          previousPage,
          nextPage,
          // totalPages,
          getPageItemProps
        }) => (
          <ListPageItem className="mb0">
            {/* <PageItem
                {...getPageItemProps({
                  pageValue: 1,
                  onPageChange: handlePageChange
                })}
              >
                First
              </PageItem> */}

            {hasPreviousPage && (
              <PageItem
                {...getPageItemProps({
                  pageValue: previousPage,
                  onPageChange: props.handlePageChange
                })}
              >
                {'Prev'}
              </PageItem>
            )}

            {pages.map(page => {
              let activePage = null;
              if (currentPage === page) {
                activePage = { color: '#4db2ec' };
              }
              return (
                <PageItem
                  key={page}
                  style={activePage}
                  {...getPageItemProps({
                    pageValue: page,
                    onPageChange: props.handlePageChange
                  })}
                >
                  {page}
                </PageItem>
              );
            })}

            {hasNextPage && (
              <PageItem
                {...getPageItemProps({
                  pageValue: nextPage,
                  onPageChange: props.handlePageChange
                })}
              >
                {'Next'}
              </PageItem>
            )}

            {/* <PageItem
                {...getPageItemProps({
                  pageValue: totalPages,
                  onPageChange: handlePageChange
                })}
              >
                Last
              </PageItem> */}
          </ListPageItem>
        )}
      </Pagination>
    </ListElement>
  );
};

export default articleList;
